<template>
  <editor-content
    v-if="part=='description'"
    :editor="editorDescription"
  />
  <editor-content
    v-else
    :editor="editorChecklist"
  />
</template>
<script>
import { Editor, EditorContent } from '@tiptap/vue-2'
import TextAlign from '@tiptap/extension-text-align'
import TextStyle from '@tiptap/extension-text-style'
import Color from '@tiptap/extension-color'
import Highlight from '@tiptap/extension-highlight'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Text from '@tiptap/extension-text'
import Bold from '@tiptap/extension-bold'
import Italic from '@tiptap/extension-italic'
import Underline from '@tiptap/extension-underline'
import BulletList from '@tiptap/extension-bullet-list'
import OrderedList from '@tiptap/extension-ordered-list'
import ListItem from '@tiptap/extension-list-item'
import Heading from '@tiptap/extension-heading'
import FontSize from './editor_extensions/font-size.js'
//import Div from './editor_extensions/div.js'
import Strike from '@tiptap/extension-strike'
import Focus from '@tiptap/extension-focus'
import HardBreak from '@tiptap/extension-hard-break'
import History from '@tiptap/extension-history'
import CustomLink from './editor_extensions/custom-link.js'
import CustomImage from './editor_extensions/custom-image.js'
//import CustomImageBanner from './editor_extensions/custom-image-banner.js'
import Placeholder from '@tiptap/extension-placeholder'
import i18n from '../plugins/i18n.js'
import Emoji from '@tiptap/extension-emoji'
import suggestion from './suggestion'
import Iframe from './editor_extensions/iframe.js'

export default {
    components: {
        EditorContent
    },
    props:{
        content: {
          type: String,
          default: ''
        },
        index: {
          type: Number,
          default: 0
        },
        part: {
          type: String,
          default: 'description'
        }
    },
    data(){
      return{
        editorDescription: null,
        editorChecklist: null,
        oldContent: this.content,
      }
    },
    created(){
     
    },
    mounted() {
      //override paragraph node - was not working in separate file
      const CustomParagraph = Paragraph.extend({
        addAttributes() {
          return {
            class: {
                default: '',
                rendered: true
            }
          }
        },
        addCommands() {
          return {
            setParagraph: attributes => ({ commands }) => {
              return commands.setNode('paragraph', attributes);
            },
          }
        }
      })

      const CustomTextStyle = TextStyle.extend({
        addAttributes() {
          return {
            class: {
                default: '',
                rendered: true
            }
          }
        },
      })

    this.editorDescription = new Editor({
      editorProps: {
        handleClick: ( ) => {
          this.setActiveEditor(this.editorDescription)
        },
        handleDoubleClick: ( ) => {
            this.editorDescription.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        Heading.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
         CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest'
        }),
        History,
        HardBreak,
        Placeholder.configure({
          includeChildren: true,
          showOnlyWhenEditable: false,
          placeholder: ({ node, editor }) => {
            if (node.type.name === 'paragraph') {
              if(editor.state.doc.textContent.length === 0){
                return i18n.t('enterDescription')
              }
            }
            return null
          },
        }),
        Emoji.configure({
          enableEmoticons: true,
          suggestion,
          HTMLAttributes: {
            class: 'emoji',
          },
        })
        //Div
      ],
      content: this.content,
      //editable: false,
      onUpdate: ({ editor}) => {
        const newContent = editor.getHTML()
        this.$emit('updateContent', newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    }),
    this.editorChecklist = new Editor({
      editorProps: {
        handleClick: ( ) => {
          this.setActiveEditor(this.editorChecklist)
        },
        handleDoubleClick: ( ) => {
            this.editorChecklist.setEditable(true)
            this.$emit('enableEditMode')
        },
        handleDOMEvents: {
            drop: (view, e) => { e.preventDefault(); },
            paste: (view, e) => {
                if(this.editorChecklist.isActive('custom-image') || this.editorChecklist.isActive('iframe')){
                    e.preventDefault();
                }
            },
            keydown: (view, e) => {
                /*if ((e.key === "Delete" || e.key === "Enter") && (this.editorChecklist.isActive('custom-image') || this.editorChecklist.isActive('iframe'))) {
                    e.preventDefault();
                }*/
                if (e.key && (this.editorChecklist.isActive('custom-image') || this.editorChecklist.isActive('iframe'))) {
                    e.preventDefault();
                }
                return false;
            }
        },
        transformPastedHTML: (html) => {
            return html.replace(/<img .*?>/g,'').replace(/<iframe .*?>/g,''); 
        }
      },
      // hide the drop position indicator
      dropCursor: { width: 0, color: 'transparent' },
      extensions: [
        Document,
        Text,
        Bold,
        Italic,
        Underline,
        Strike,
        Highlight,
        CustomLink.configure({
          openOnClick: false,
          HTMLAttributes: {
            target: '_blank',
          },
        }),
        BulletList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        OrderedList.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        ListItem,
        Heading.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        TextAlign.configure({
          types: ['heading', 'paragraph'],
        }),
        CustomParagraph.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
         CustomTextStyle,
        Color,
        FontSize,
        Focus.configure({
          className: 'has-focus',
          mode: 'deepest'
        }),
        History,
        HardBreak,
        Iframe,
        //ExternalVideo,
        CustomImage.configure({
          HTMLAttributes: {
            class: 'add-transparent-border',
          },
        }),
        Emoji.configure({
          enableEmoticons: true,
          suggestion,
          HTMLAttributes: {
            class: 'emoji',
          },
        })
        /*CustomImageBanner.configure({
          HTMLAttributes: {
            class: 'd-flex',
          },
        })*/
        //Div
      ],
      content: this.content,
      //editable: false,
      onUpdate: ({ editor}) => {
        const newContent = editor.getHTML()
        this.$emit('updateContent',this.index, newContent)
      },
      onSelectionUpdate: ({ editor}) => {
        this.$emit('proceedClick',editor)
        const { view: { state: { tr: { selection } } } } = editor
        this.$emit('proceedMark', !selection.empty)
      },
    })
  },

  beforeUnmount() {
    this.editorDescription.destroy()
    this.editorChecklist.destroy()
  },
   methods: {
    setActiveEditor(editor){
        this.$emit('proceedClick',editor)
    }
  }
}
</script>